export var complaints_claims = `
    The member may send any complaints or claims to the email <a href="mailto:legal@eurecat.org">legal@eurecat.org</a>. <br/><br/>
	FUNDACIÓ EURECAT will respond to the claims received as quickly as possible and always within one month from when the claim is received. <br/><br/>
`;